import React, { Component } from 'react'
import style from './style.module.less'
import mainStore from '@components/Main/store'
import { observer } from 'mobx-react'
import ErrorBoundary from '@common/ErrorBoundary'
import NoticeChat from './NoticeChat'
import { getUrlParam } from '@core/utils'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    mainStore.contentMainDiv = React.createRef()

    // url 上有 debug 参数，则不启用 ErrorBoundary，便于控制台显示错误
    this.isDebug = !!getUrlParam('debug')
  }

  componentDidUpdate(prevProps) {
    // 当路由切换时，主内容区域重置到顶部
    if (prevProps.location.pathname !== this.props.location.pathname) {
      mainStore.scrollTopMain()
    }
  }

  render() {
    const { children } = this.props
    const node = (
      <div
        className={style.content_main}
        ref={mainStore.contentMainDiv}
        id="contentMainDiv"
      >
        {children}
      </div>
    )
    return (
      <div className={style.content}>
        {this.isDebug ? node : <ErrorBoundary>{node}</ErrorBoundary>}
        <NoticeChat />
      </div>
    )
  }
}
